import axios from "../../axios";

//App版本信息列表
export const list = (data) => {
  return axios({
    url: '/system/appVersion/list',
    method: 'post',
    data
  })
}

//App应用平台、类型
export const getAppPlatformTypeList = (data) => {
  return axios({
    url: '/system/appVersion/getAppPlatformTypeList',
    method: 'post',
    data
  })
}

//App版本详情
export const view = (data) => {
  return axios({
    url: '/system/appVersion/view',
    method: 'post',
    data
  })
}

//App版本信息保存
export const save = (data) => {
  return axios({
    url: '/system/appVersion/save',
    method: 'post',
    data
  })
}

//App版本信息保存
export const singleDelete = (data) => {
  return axios({
    url: '/system/appVersion/delete',
    method: 'post',
    data
  })
}

//获取App下载地址
export const appUpgradeCheck = (data) => {
  return axios({
    url: '/app/login/appUpgradeCheck',
    method: 'post',
    data
  })
}






// WEBPACK FOOTER //
// ./src/http/moudules/sys/sysAppVersion.js